<template>
  <v-container v-if="stack.api.getLoaded" class="text-start">
      <h2>
          {{ stack.name }}
          <v-btn
                  v-if="canEditStacks"
                  secondary
                  @click="editStack()"
              >
              <v-icon left>mdi-pencil></v-icon> {{ $t('nav.edit') }}
          </v-btn>
      </h2>
      <v-simple-table fixed-header>
          <thead>
          <tr>
              <th></th>
              <th></th>
              <th></th>
          </tr>
          </thead>
          <tbody>
<!--          <tr>-->
<!--              <td><v-icon>today</v-icon> {{ $t('field.seenToday') }}</td>-->
<!--              <td>{{ yesOrNo(stack.seenToday) }}</td>-->
<!--              <td></td>-->
<!--          </tr>-->
          <tr>
              <td><v-icon>view_module</v-icon> {{ $t('field.entireStack') }}</td>
              <td>{{ a2h(stack.cardCount) }}</td>
              <td>
                  <v-btn v-if="stack.cardCount" :color="yellow" @click="startQuiz(-1)">
                      {{ $t('nav.quiz') }}
                  </v-btn>
              </td>
          </tr>
          <tr>
              <td><v-icon>close</v-icon> {{ $t('field.notMemorized') }}</td>
              <td>{{ a2h(stack.status.level0Count) }}</td>
              <td>
                  <v-btn v-if="stack.status.level0Count" :color="yellow" @click="startQuiz(0)">
                      {{ $t('nav.quiz') }}
                  </v-btn>
              </td>
          </tr>
          <tr>
              <td><v-icon>check</v-icon> {{ $t('field.memorizedShortTerm') }}</td>
              <td>{{ a2h(stack.status.level1Count) }}</td>
              <td>
                  <v-btn v-if="stack.status.level1Count" :color="yellow" @click="startQuiz(1)">
                      {{ $t('nav.quiz') }}
                  </v-btn>
              </td>
          </tr>
          <tr>
              <td><v-icon>star</v-icon> {{ $t('field.memorizedLongTerm') }}</td>
              <td>{{ a2h(stack.status.level2Count) }}</td>
              <td>
                  <v-btn v-if="stack.status.level2Count" :color="yellow" @click="startQuiz(2)">
                      {{ $t('nav.quiz') }}
                  </v-btn>
              </td>
          </tr>
          </tbody>
      </v-simple-table>
      <v-container>
          <v-btn @click="returnToCardset()">{{ $t('nav.returnToCardset') }}</v-btn>
          <v-btn @click="gotoCardList()" :class="classButtonRight">{{ $t('nav.gotoCardList') }}</v-btn>
      </v-container>
      <stack-edit v-if="canEditStacks" :pk="stack.id" v-model="dialog" @closed="dialog = false"></stack-edit>
  </v-container>

    <v-container v-else>
        <h2 class="text-center">
            {{ $t('nav.loading') }}
        </h2>
    </v-container>
</template>

<script>
import StackEdit from "./StackEdit";
import basic from "../mixins/basic";
import {Stack} from "@/models/Stack";
import StackMixin from "@/components/mixins/StackMixin";

export default {
    name: "StackDetail",
    components: {StackEdit},
    mixins: [basic, StackMixin],
    props: {
        pk: {
            required: true,
            type: Number,
        },
        cardsetId: {
            required: false,
            type: Number
        }
    },
    data: function () {
        return {
            detailUrl: '/stack/',
            stack: new Stack(),
            dialog: false,
        }
    },
    methods: {
        editStack() {
            this.dialog = true;
        },
        setBreadCrumbs() {
            this.$store.dispatch('resetBreadCrumbs');
            this.$store.commit('pushBreadCrumb', {
                text: this.cardset.name,
                to: {
                    name: 'cardset-detail',
                    params: {
                        pk: this.cardsetId,
                    }
                },
                enabled: true,
            });
            this.$store.commit('pushBreadCrumb', {
                text: this.stack.name,
                to: {
                    name: 'stack-drill',
                    params: {
                        pk: this.pk,
                        cardsetId: this.cardsetId,
                    }
                },
                enabled: true,
            });

        }
    },
    computed: {},
    created() {
        let that = this;
        this.stack.api.fetch(this.pk).then(function () {
            that.fetchCardset(that.cardsetId).then(function () {
                that.setBreadCrumbs();
            });
        });
    }
}
</script>

<style scoped>

</style>
